export const OPTIONS_CONTAINER_TYPE = [
  {
    id: 1, name: '20’ FT Dry (Standard)', size: 20, type: 'Dry (Standard)'
  },
  {
    id: 2, name: '40’ FT Dry (Standard)', size: 40, type: 'Dry (Standard)'
  },
  {
    id: 12, name: '45’ FT Dry (Standard)', size: 45, type: 'Dry (Standard)'
  },
  {
    id: 3, name: '40’ FT HC Dry (Standard)', size: 40, type: 'HC Dry (Standard)'
  },
  {
    id: 4, name: '20’ FT Reefer', size: 20, type: 'Reefer'
  },
  {
    id: 5, name: '40’ FT HC Reefer', size: 40, type: 'HC Reefer'
  },
  {
    id: 6, name: '20’ FT Flatrack', size: 20, type: 'Flatrack'
  },
  {
    id: 7, name: '40’ FT Flatrack', size: 40, type: 'Flatrack'
  },
  {
    id: 8, name: '20’ FT Open Top', size: 20, type: 'Open Top'
  },
  {
    id: 9, name: '40’ FT Open Top', size: 40, type: 'Open Top'
  },
  {
    id: 10, name: '20’ FT ISO Tank', size: 20, type: 'ISO Tank'
  },
  {
    id: 11, name: '40’ FT ISO Tank', size: 40, type: 'ISO Tank'
  }
]

export const OPTIONS_WEIGHT_RANGE = [
  { id: 1, name: '< 45 Kg', value: 1 },
  { id: 2, name: '+ 45 Kg', value: 45 },
  { id: 3, name: '+ 100 Kg ', value: 100 },
  { id: 4, name: '+ 250 Kg ', value: 250 },
  { id: 5, name: '+ 500 Kg ', value: 500 },
  { id: 6, name: '+ 1000 Kg ', value: 1000 }
]

export const OPTIONS_PRODUCT_TYPE = [
  { id: 1, value: 'GENCO', name: 'General Cargo' },
  { id: 2, value: 'SC', name: 'Special Cargo' },
  { id: 3, value: 'DG', name: 'Dangerous Goods' }
]

export const OPTIONS_GENCO = [
  { id: 1, text: 'Agricultural Products' },
  { id: 2, text: 'Arts, Crafts, and Collectibles' },
  { id: 3, text: 'Automotive’s Sparepart and Accessories' },
  { id: 4, text: 'Chemicals' },
  { id: 5, text: 'Durable Goods' },
  { id: 6, text: 'Electronic Equipment and Accessories' },
  { id: 7, text: 'Food and Beverages' },
  { id: 8, text: 'Furniture and Home Appliance' },
  { id: 9, text: 'Health and Personal Care' },
  { id: 10, text: 'Machinery and Spareparts' },
  { id: 11, text: 'Medical and Laboratory Equipment' },
  { id: 12, text: 'Minnings and Natural Resources' },
  { id: 13, text: 'Others' },
  { id: 14, text: 'Paper and Plastics' },
  { id: 15, text: 'Perishable' },
  { id: 16, text: 'Retail (Fashion Retail)' },
  { id: 17, text: 'Textile and Garment' },
  { id: 18, text: 'Toys and Hobbies' },
  { id: 19, text: 'Wood' }
]

export const OPTIONS_SC = [
  { id: 1, text: 'Human Remain (HUM)' },
  { id: 2, text: 'Live Animal (AVI)' },
  { id: 3, text: 'Live Human Organ (LHO)' },
  { id: 4, text: 'Others' },
  { id: 5, text: 'Perishable Goods (PER)' },
  { id: 6, text: 'Smelling Goods' },
  { id: 7, text: 'Valuable Goods (VAL)' }

]

export const OPTIONS_DG = [
  { id: 1, text: 'Corrosive (RCM)' },
  { id: 2, text: 'Explosive Goods (REX)' },
  { id: 3, text: 'Flammable Liquids (RFL)' },
  { id: 4, text: 'Flammable Solids (RFS)' },
  { id: 5, text: 'Gasses (RPG)' },
  { id: 6, text: 'Misscelanous Dangerous Goods (RMD)' },
  { id: 7, text: 'Others' },
  { id: 8, text: 'Oxidizer (ROX)' },
  { id: 9, text: 'Radiactive Material (RFN)' },
  { id: 10, text: 'Toxic (RPB) & Infections Substances (RI)' }
]

export const OPTIONS_BL_TYPE = [
  { id: 1, name: 'Original', value: 'Original' },
  { id: 2, name: 'Surrender', value: 'Surrender' },
  { id: 3, name: 'Telex Release', value: 'Telex Release' },
  { id: 4, name: 'Sea Way Bill', value: 'Sea Way Bill' }
]

export const OPTIONS_TERMS = [
  { id: 1, name: 'Container Yard / Container Yard', value: 'CY/CY' },
  { id: 2, name: 'Container Freight Station / Container Freight Station', value: 'CFS/CFS' },
  { id: 3, name: 'Container Yard / Free Out', value: 'CY/FO' }
]

// -- Quantity Unit -- //
export const UNIT_COMMODITY_QUANTITY = [
  { id: 1, value: 'Boxes', name: 'Boxes' },
  { id: 2, value: 'Cartons', name: 'Cartons' },
  { id: 3, value: 'Cases', name: 'Cases' },
  { id: 4, value: 'Drums', name: 'Drums' },
  { id: 5, value: 'Packages', name: 'Packages' },
  { id: 6, value: 'Palletes', name: 'Palletes' }
]

export const UNIT_COMMODITY_QUANTITY_AIR_BREAKBULK = [
  { id: 1, value: 'Units', name: 'Units' },
  { id: 2, value: 'Charters', name: 'Charters' },
  { id: 3, value: 'CBM', name: 'CBM' }
]

export const UNIT_COMMODITY_QUANTITY_OCEAN_BREAKBULK = [
  { id: 1, value: 'Cartons', name: 'Cartons' },
  { id: 2, value: 'Drums', name: 'Drums' },
  { id: 3, value: 'Packages', name: 'Packages' },
  { id: 4, value: 'Palletes', name: 'Palletes' }
]

export const UNIT_COMMODITY_QUANTITY_FCL = [
  { id: 1, value: 'Cartons', name: 'Cartons' },
  { id: 2, value: 'Packages', name: 'Packages' },
  { id: 3, value: 'Palletes', name: 'Palletes' }
]

export const OPTIONS_UOM_BREAKBULK = [
  { id: 1, value: 'Unit', name: 'Per Unit' },
  { id: 2, value: 'Charter', name: 'Per Charter' },
  { id: 3, value: 'CBM', name: 'Per CBM' }
]



// WEBPACK FOOTER //
// ./src/constant/options_list.js